import { FormInput } from "components";
import { ERROR_MESSAGE } from "constants/global";

const LastName = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.last_name || ""}
    register={register("last_name", {
      required: ERROR_MESSAGE.LAST_NAME,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.LAST_NAME,
    })}
    error={errors?.last_name?.message}
    placeholder="姓"
  />
);

const FirstName = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.first_name || ""}
    register={register("first_name", {
      required: ERROR_MESSAGE.FIRST_NAME,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.FIRST_NAME,
    })}
    error={errors?.first_name?.message}
    placeholder="名"
  />
);

const LastNameKana = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.last_name_kana || ""}
    register={register("last_name_kana", {
      required: ERROR_MESSAGE.LAST_NAME_PARTNER_KANA,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.LAST_NAME_PARTNER_KANA,
    })}
    error={errors?.last_name_kana?.message}
    placeholder="性（セイ）"
  />
);

const FirstNameKana = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.first_name_kana || ""}
    register={register("first_name_kana", {
      required: ERROR_MESSAGE.FIRST_NAME_PARTNER_KANA,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.FIRST_NAME_PARTNER_KANA,
    })}
    error={errors?.first_name_kana?.message}
    placeholder="名（メイ）"
  />
);

const Email = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.email || ""}
    register={register("email")}
  />
);

const Age = ({ partnerInfo, register, errors, errorAge, clearError }) => (
  <FormInput
    defaultValue={partnerInfo?.age || ""}
    register={register("age", {
      required: ERROR_MESSAGE.AGE,
      onChange: () => clearError(),
      pattern: {
        value: /^([0-9]{0,3})$/,
        message: ERROR_MESSAGE.AGE,
      },
    })}
    type="tel"
    onlyNumber={true}
    maxlength={3}
    border={errors?.age?.message || errorAge}
  />
);

const Phone = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.phone || ""}
    register={register("phone", {
      required: ERROR_MESSAGE.PHONE.REQUIRED,
      pattern: {
        value: /^([0-9]{10}|[0-9]{11})$/,
        message: ERROR_MESSAGE.PHONE.INVALID,
      },
    })}
    type="tel"
    onlyNumber={true}
    maxlength={11}
    error={errors?.phone?.message}
  />
);

const GenderAdd = ({ register, value, id, label, errors }) => (
  <div className="box-gender">
    <input
      {...register("gender", {
        required: ERROR_MESSAGE.GENDER,
      })}
      type="radio"
      name="gender"
      value={value}
      className="check-gender"
      id={"gender" + id}
    />
    <label
      className={`lblradio ${errors?.gender ? "is-invalid" : ""}`}
      htmlFor={"gender" + id}
    >
      {label}
    </label>
  </div>
);

const Gender = ({ register, value, partnerInfo, id, label, errors }) => (
  <div className="box-gender">
    <input
      {...register("gender", {
        required: ERROR_MESSAGE.GENDER,
      })}
      type="radio"
      name="gender"
      value={value}
      defaultChecked={partnerInfo?.gender == value ? true : false}
      className="check-gender"
      id={id}
    />
    <label
      className={`lblradio ${errors?.gender ? "is-invalid" : ""}`}
      htmlFor={id}
    >
      {label}
    </label>
  </div>
);

const PromotionSetField = ({ register, promotionset }) => (
  <>
    <input
      type="checkbox"
      className="check-clap"
      id={"promotion_set_id-" + promotionset.id}
      value={+promotionset.id}
      name="promotion_set_id"
      {...register(`promotion_set_id`, {
        required: ERROR_MESSAGE.PROMOTION_SET,
      })}
    />
    <label
      htmlFor={"promotion_set_id-" + promotionset.id}
      className="fs-14 lh-1"
    >
      {promotionset.name}
    </label>
  </>
);

// validate age / gender
const checkPromotionSets = (promotion, promotion_set_id, age, gender) => {
  let errorValidate = [];
  if(gender == 1) {
    if(promotion.gender1 == '2' && promotion.gender2 == '3' && promotion.gender3 == '3') {
      errorValidate = [
        ...errorValidate,
        `当案件は同行者の登録が女性のみです`
      ];
    } else if (promotion.gender1 == '3' && promotion.gender2 == '2' && promotion.gender3 == '3') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が女性のみです`
        ];
    } else if (promotion.gender1 == '3' && promotion.gender2 == '3' && promotion.gender3 == '2') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が女性のみです`
        ];
    } else if (promotion.gender1 == '2' && promotion.gender2 == '2' && promotion.gender3 == '3') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が女性のみです`
        ];
    } else if (promotion.gender1 == '3' && promotion.gender2 == '2' && promotion.gender3 == '2') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が女性のみです`
        ];
    } else if (promotion.gender1 == '2' && promotion.gender2 == '2' && promotion.gender3 == '2') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が女性のみです`
        ];
    } else {
      if(promotion.gender1 == '' || promotion.gender1 == '0' || promotion.gender1 == '1' || promotion.gender1 == '3') {
          if(promotion.age1_from == '' && promotion.age1_to != '') {
              if(age > promotion.age1_to) {
                errorValidate = [
                  ...errorValidate,
                  `男性の${promotion.age1_to}才未満の年齢を入力してください`
                ];
              }
          } else if(promotion.age1_from != '' && promotion.age1_to == '') {
              if(age < promotion.age1_from) {
                errorValidate = [
                  ...errorValidate,
                  `男性の${promotion.age1_from}才超過年齢を入力してください`
                ];
              }
          } else if(promotion.age1_from != '' && promotion.age1_to != '') {
              if(age < promotion.age1_from ||  age > promotion.age1_to) {
                errorValidate = [
                  ...errorValidate,
                  `男性:${promotion.age1_from}～${promotion.age1_to}才以内の年齢を入力してください`
                ];
              }
          }
      }
      
      if(promotion.gender2 == '' || promotion.gender2 == '0' || promotion.gender2 == '1' || promotion.gender2 == '3') {
          if(promotion.age2_from == '' && promotion.age2_to != '') {
              if(age > promotion.age2_to) {
                errorValidate = [
                  ...errorValidate,
                  `男性の${promotion.age2_to}才未満の年齢を入力してください`
                ];
              }
          } else if(promotion.age2_from != '' && promotion.age2_to == '') {
              if(age < promotion.age2_from) {
                errorValidate = [
                  ...errorValidate,
                  `男性の${promotion.age2_from}才超過年齢を入力してください`
                ];
              }
          } else if(promotion.age2_from != '' && promotion.age2_to != '') {
              if(age < promotion.age2_from || age > promotion.age2_to) {
                errorValidate = [
                  ...errorValidate,
                  `男性:${promotion.age2_from}～${promotion.age2_to}才以内の年齢を入力してください`
                ];
              }
          }
      }
      if(promotion.gender3 == '' || promotion.gender3 == '0' || promotion.gender3 == '1' || promotion.gender3 == '3') {
          if(promotion.age3_from == '' && promotion.age3_to != '') {
              if(age > promotion.age3_to) {
                errorValidate = [
                  ...errorValidate,
                  `男性の${promotion.age3_to}才未満の年齢を入力してください`
                ];
              }
          } else if(promotion.age3_from != '' && promotion.age3_to == '') {
              if(age < promotion.age3_from) {
                errorValidate = [
                  ...errorValidate,
                  `男性の${promotion.age3_from}才超過年齢を入力してください`
                ];
              }
          } else if(promotion.age3_from != '' && promotion.age3_to != '') {
              if(age < promotion.age3_from || age > promotion.age3_to) {
                errorValidate = [
                  ...errorValidate,
                  `男性:${promotion.age3_from}～${promotion.age3_to}才以内の年齢を入力してください`
                ];
              }
          }
      }
    }
  } else {
    if(promotion.gender1 == '1' && promotion.gender2 == '3' && promotion.gender3 == '3') {
      errorValidate = [
        ...errorValidate,
        `当案件は同行者の登録が男性のみです`
      ];
    } else if (promotion.gender1 == '3' && promotion.gender2 == '1' && promotion.gender3 == '3') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が男性のみです`
        ];
    } else if (promotion.gender1 == '3' && promotion.gender2 == '3' && promotion.gender3 == '1') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が男性のみです`
        ];
    } else if (promotion.gender1 == '1' && promotion.gender2 == '1' && promotion.gender3 == '3') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が男性のみです`
        ];
    } else if (promotion.gender1 == '3' && promotion.gender2 == '1' && promotion.gender3 == '1') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が男性のみです`
        ];
    } else if (promotion.gender1 == '1' && promotion.gender2 == '1' && promotion.gender3 == '1') {
        errorValidate = [
          ...errorValidate,
          `当案件は同行者の登録が男性のみです`
        ];
    } else {
      if(promotion.gender1 == '' || promotion.gender1 == '0' || promotion.gender1 == '2' || promotion.gender1 == '3') {
          if(promotion.age1_from == '' && promotion.age1_to != '') {
              if(age > promotion.age1_to) {
                errorValidate = [
                  ...errorValidate,
                  `女性の${promotion.age1_to}才未満の年齢を入力してください`
                ];
              }
          } else if(promotion.age1_from != '' && promotion.age1_to == '') {
              if(age < promotion.age1_from) {
                errorValidate = [
                  ...errorValidate,
                  `女性の${promotion.age1_from}才超過年齢を入力してください`
                ];
              }
          } else if(promotion.age1_from != '' && promotion.age1_to != '') {
              if(age < promotion.age1_from || age > promotion.age1_to) {
                errorValidate = [
                  ...errorValidate,
                  `女性:${promotion.age1_from}～${promotion.age1_to}才以内の年齢を入力してください`
                ];
              }
          }
      }
      if(promotion.gender2 == '' || promotion.gender2 == '0' || promotion.gender2 == '2' || promotion.gender2 == '3') {
          if(promotion.age2_from == '' && promotion.age2_to != '') {
              if(age > promotion.age2_to) {
                errorValidate = [
                  ...errorValidate,
                  `女性の${promotion.age2_to}才未満の年齢を入力してください`
                ];
              }
          } else if(promotion.age2_from != '' && promotion.age2_to == '') {
              if(age < promotion.age2_from) {
                errorValidate = [
                  ...errorValidate,
                  `女性の${promotion.age2_from}才超過年齢を入力してください`
                ];
              }
          } else if(promotion.age2_from != '' && promotion.age2_to != '') {
              if(age < promotion.age2_from || age > promotion.age2_to) {
                errorValidate = [
                  ...errorValidate,
                  `女性:${promotion.age2_from}～${promotion.age2_to}才以内の年齢を入力してください`
                ];
              }
          }
      }
      if(promotion.gender3 == '' || promotion.gender3 == '0' || promotion.gender3 == '2' || promotion.gender3 == '3') {
          if(promotion.age3_from == '' && promotion.age3_to != '') {
              if(age > promotion.age3_to) {
                errorValidate = [
                  ...errorValidate,
                  `女性の${promotion.age3_to}才未満の年齢を入力してください`
                ];
              }
          } else if(promotion.age3_from != '' && promotion.age3_to == '') {
              if(age < promotion.age3_from) {
                errorValidate = [
                  ...errorValidate,
                  `女性の${promotion.age3_from}才超過年齢を入力してください`
                ];
              }
          } else if(promotion.age3_from != '' && promotion.age3_to != '') {
              if(age < promotion.age3_from || age > promotion.age3_to) {
                errorValidate = [
                  ...errorValidate,
                  `女性:${promotion.age3_from}～${promotion.age3_to}才以内の年齢を入力してください`
                ];
              }
          }
      }
    }
  }
  return errorValidate;
};

export {
  FirstName,
  LastName,
  Age,
  Phone,
  GenderAdd,
  Gender,
  PromotionSetField,
  checkPromotionSets,
  FirstNameKana,
  LastNameKana,
  Email
};
